<template>
    <b-modal :title="title" centered no-close-on-backdrop no-close-on-esc hide-header-close size="lg" ref="mdlPostiLettoAccettazione" scrollable @show="onShow">
        <!-- @ok="onClickSavePostoLetto" ok-title="Salva" -->
        <b-row>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <label for="" class="sa-label-data">Piano</label>
                <b-input-group class="mb-3">
                    <b-form-select autocomplete="off" v-model="filtro.nomePiano" :options="pianoOptions" @change="onChangePiano">
                        <template #first>
                            <b-form-select-option :value="null" disabled> - Filtra per piano - </b-form-select-option>
                        </template>
                    </b-form-select>
                </b-input-group>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <label for="" class="sa-label-data">Stanza</label>
                <b-input-group class="mb-3">
                    <b-form-select autocomplete="off" v-model="filtro.nomeStanza" :options="stanzeOptions" @change="onChangeStanza">
                        <template #first>
                            <b-form-select-option :value="null" disabled>- Filtra per stanza - </b-form-select-option>
                        </template>
                    </b-form-select>
                </b-input-group>
            </b-col>
        </b-row>
        <b-card class="sa-card sa-card-border mt-4" header="Lista" header-tag="header" footer-tag="footer" title="">
            <b-table ref="table" select-mode="single" responsive stacked="lg" striped hover :items="items" :fields="fields" :current-page="currentPage" :per-page="perPage" sort-icon-left head-variant="light" class="sa-b-table" selectable @row-selected="onRowSelected">
                <template #cell(selected)="{ rowSelected }">
                    <template v-if="rowSelected">
                        <span aria-hidden="true">&check;</span>
                        <span class="sr-only">Selected</span>
                    </template>
                    <template v-else>
                        <span aria-hidden="true">&nbsp;</span>
                        <span class="sr-only">Not selected</span>
                    </template>
                </template>
                <template #cell(index)="row">
                    {{ (currentPage - 1) * perPage + row.index + 1 }}
                </template>
                <template #cell(nome)="item">{{ item.item.nome }}</template>
                <template #cell(nomeStanza)="item">{{ item.item.nomeStanza }}</template>
                <template #cell(sesso)="item">{{ item.item.descrizioneSesso }}</template>
            </b-table>
            <b-row>
                <b-col cols="12">
                    <p>Risultati totali: {{ rows }}</p>
                </b-col>
            </b-row>
        </b-card>
        <template #modal-footer>
            <b-button @click="onClickCloseModal" variant="outline-danger" size="md">Annulla</b-button>
            <b-button v-if="isTrasferimentoPaziente" @click="onClickSavePostoLettoTrasferimento" variant="outline-success" size="md">Salva</b-button>
            <b-button v-else @click="onClickSavePostoLetto" variant="outline-success" size="md">Salva</b-button>
        </template>
        <modal-error ref="cmpModalError"> </modal-error>
    </b-modal>
</template>

<script>
import UtilityMixin from "../../../utility/UtilityMixin";
import ModalError from "../../../../template/components/modal/components/ModalError.vue";
/* import RsaAccettazionePostiLettoListComponent from "./RsaAccettazionePostiLettoListComponent.vue"; */

export default {
    name: "RsaAssegnaPostoLettoModalEditComponent",
    mixins: [UtilityMixin],
    components: { ModalError },
    props: {
        isTrasferimentoPaziente: {
            type: Boolean,
            default: function () {
                return false;
            },
        },
    },
    computed: {
        rows() {
            return this.items.length;
        },
    },
    data() {
        return {
            pathResource: "/rsapostilettoaccettazione",
            pathResourcePostiLettoPiani: "/rsapostilettopiani",
            pathResourcePostiLettoStanze: "/rsapostilettostanze",
            pathResourcePostiLettoLetto: "/rsapostilettoletti",
            title: null,
            currentPage: 1,
            perPage: 100,
            rowSelected: [],
            struttura: null,
            idPiano: null,
            pianoOptions: [],
            stanzeOptions: [],
            idAccettazione: null,
            denominazionePresidio: null,
            presidio: null,
            items: [],
            // filtroLetto: {},
            filtroStanze: {},
            filtroPiani: {},
            codiceStruttura: null,
            selectedElement: [],
            jsonData: {
                idAccettazione: this.idAccettazione,
                idLetto: null,
                note: null,
                codiceReparto: null,
                descrizioneReparto: null,
                nomeStanza: null,
                sesso: null,
                nomePiano: null,
                tipoLetto: null,
                nomeLetto: null,
            },
            filtro: { nomePiano: null, nomeStanza: null, statoAttuale: "DISPONIBILE" },
            fields: [
                {
                    label: "",
                    key: "selected",
                    thStyle: "width: 0.2rem",
                    tdClass: "text-center",
                },

                {
                    label: "*",
                    key: "index",
                },
                {
                    label: "Piano",
                    key: "nomePiano",
                },
                {
                    label: "Stanza",
                    key: "nomeStanza",
                },
                {
                    label: "Letto",
                    key: "nome",
                },
                {
                    label: "Tipo letto",
                    key: "tipoLetto",
                },
                {
                    label: "Tipologia stanza",
                    key: "sesso",
                },
            ],
        };
    },
    watch: {
        selectedElement: function (newVal) {
            let me = this;
            if (!newVal || newVal.length === 0) {
                me.jsonData.nomeLetto = null;
                me.jsonData.nomePiano = null;
                me.jsonData.nomeStanza = null;
                me.jsonData.tipoLetto = null;
                me.jsonData.idLetto = null;
                me.jsonData.codiceReparto = null;
                me.jsonData.descrizioneReparto = null;
                return;
            }
            const selectedItem = newVal[0];
            me.jsonData.nomeLetto = selectedItem.nome;
            me.jsonData.tipoLetto = selectedItem.tipoLetto;
            me.jsonData.idLetto = selectedItem.id;
            me.jsonData.codiceReparto = selectedItem.codiceReparto;
            me.jsonData.descrizioneReparto = selectedItem.descrizioneReparto;
            me.jsonData.nomePiano = selectedItem.nomePiano;
            me.jsonData.nomeStanza = selectedItem.nomeStanza;
            me.presidio = selectedItem.idPresidio;
            me.denominazionePresidio = selectedItem.denominazionePresidio;
            // console.log("letto selezionato: ", me.selectedElement);
        },
    },
    methods: {
        show(item) {
            let me = this;
            me.idAccettazione = item.id;
            me.filtro.codiceSesso = item.sesso;
            me.filtro.idPresidio = item.idPresidio;
            me.filtro.nomeStanza = null;
            me.filtro.nomePiano = null;
            me.jsonData = { idAccettazione: item.id, sesso: item.sesso };
            // me.filtroLetto = { codiceSesso: item.sesso, idPresidio: item.idPresidio };
            me.filtroPiani = { idPresidio: item.idPresidio };
            me.title = "Assegna Posto Letto";
            me.$refs.mdlPostiLettoAccettazione.show();
        },

        onChangePiano(item) {
            let me = this;
            let selectedPiano = me.pianoOptions.find((piano) => piano.value === item);
            me.filtro.nomeStanza = null;
            if (selectedPiano) {
                me.filtroStanze = { idPiano: selectedPiano.id, sesso: me.jsonData.sesso };
                me.loadDataPostiLettoStanze();
                //me.filtroLetto = { codiceSesso : me.jsonData.sesso, nomePiano: item };
                me.loadDataPostiLettoLetti();
            } else {
                me.stanzeOptions = [];
            }
        },

        onChangeStanza() {
            let me = this;
            // const selectedStanza = me.stanzeOptions.find((stanza) => stanza.value === item);

            // if (selectedStanza) {
            //     me.filtroLetto = {
            //         codiceSesso: me.jsonData.sesso,
            //         nomePiano: me.jsonData.nomePiano,
            //         nomeStanza: item,
            //     };
            me.loadDataPostiLettoLetti();
            // }
        },

        loadDataPostiLettoPiani() {
            let me = this;
            me.loadDataResources(me.pathResourcePostiLettoPiani, me.filtroPiani, me.loadDataPianiSuccess, me.loadDataPianiError);
        },
        loadDataPianiSuccess(response) {
            let me = this;
            if (response.data.data.list) {
                me.pianoOptions = response.data.data.list.map((piano) => ({
                    value: piano.nome,
                    text: piano.nome,
                    id: piano.id,
                }));
                // console.log("PianoOptions nel loadPianoSuccess", me.pianoOptions);
            } else {
                me.pianoOptions = [];
            }
        },
        loadDataPianiError(response) {
            let me = this;
            me.$bvToast.toast("Errore nel caricamento dei dati", response, {
                title: "Errore",
                variant: "danger",
                solid: true,
            });
        },
        loadDataPostiLettoStanze() {
            let me = this;
            me.loadDataResources(me.pathResourcePostiLettoStanze, me.filtroStanze, me.loadDataStanzeSuccess, me.loadDataStanzeError);
        },
        loadDataStanzeSuccess(response) {
            let me = this;
            if (response.data.data.list) {
                me.stanzeOptions = response.data.data.list.map((stanza) => ({
                    value: stanza.nome,
                    text: stanza.nome,
                }));
                // console.log("Stanze options nel load", me.stanzeOptions);
            } else {
                me.stanzeOptions = [];
            }
        },
        loadDataStanzeError(response) {
            let me = this;
            me.$bvToast.toast("Errore nel caricamento dei dati", response, {
                title: "Errore",
                variant: "danger",
                solid: true,
            });
        },
        loadDataPostiLettoLetti() {
            let me = this;
            me.loadDataResources(me.pathResourcePostiLettoLetto, me.filtro, me.loadDataLettoSuccess, me.loadDataLettoError);
            // console.log("FILTRO IN LETTI", me.filtro);
        },
        loadDataLettoSuccess(response) {
            let me = this;
            // if (response.data.data.list) {
            me.items = response.data.data.list.filter((letti) => letti.statoAttuale === "DISPONIBILE");
            //}
        },
        loadDataLettoError(response) {
            let me = this;
            me.$bvToast.toast("Errore nel caricamento dei dati", response, {
                title: "Errore",
                variant: "danger",
                solid: true,
            });
        },
        onClickCloseModal() {
            let me = this;
            me.jsonData = { sesso: me.jsonData.sesso };
            me.selectedElement = [];
            me.rowSelected = [];
            me.stanzeOptions = [];
            me.pianoOptions = [];
            me.items = [];
            me.$refs.mdlPostiLettoAccettazione.hide();
        },
        onClickSavePostoLetto() {
            let me = this;
            me.$emit("beforeLoadData");
            me.saveResource(me.pathResource, me.jsonData, me.savePostoLettoSuccess, me.savePostoLettoError);
            // console.log("json da salvare: ", me.jsonData);
        },
        savePostoLettoSuccess(response) {
            let me = this;
            me.$emit("afterLoadData", response);
            //  me.ricovera();
            me.$bvToast.toast("Ricovero avvenuto con successo", {
                title: "Successo",
                variant: "success",
                solid: true,
            });
            me.$refs.mdlPostiLettoAccettazione.hide();
        },
        savePostoLettoError(error) {
            let me = this;
            me.$refs.cmpModalError.show(error.response.data.messaggio);
            me.$emit("afterLoadData", error);
        },
        // ricovera() {
        //     let me = this;
        //     let accettazioneStato = { idAccetazione: me.jsonData.idAccetazione, stato: "RICOVERATO" };
        //     me.saveResource(me.pathResource + "/aggiornastato", accettazioneStato, me.loadRicoveraSuccess, me.loadRicoveraError);
        // },
        // loadRicoveraSuccess(response) {
        //     let me = this;
        //     me.$bvToast.toast("OK", response, {
        //         title: "Success",
        //         variant: "success",
        //         solid: true,
        //     });
        // },
        // loadRicoveraError(response) {
        //     console.error(response);
        // },

        onRowSelected(items) {
            let me = this;
            me.selectedElement = items.length ? [items[0]] : [];
        },
        onShow() {
            let me = this;
            if (me.idAccettazione) {
                me.loadDataPostiLettoLetti();
                me.loadDataPostiLettoPiani();
            }
        },
        onClickSavePostoLettoTrasferimento() {
            let me = this;
            me.$emit("updateAccettazionePostoLetto", me.jsonData);
            me.$refs.mdlPostiLettoAccettazione.hide();
        },
    },
};
</script>

<style></style>
